<template>
    <svg class="home-page__svg" width="1280" height="660" viewBox="2880 0 1280 660" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2879.5 460H2930.5L2950.04 439.597L2950.96 27.8796L2970 8H2998" stroke="#00A4FF" stroke-width="2"/>
        <circle cx="3141.5" cy="8" r="4.5" fill="#00A4FF" stroke="#00A4FF"/>
        <circle cx="2997.5" cy="8" r="4.5" fill="#00A4FF" stroke="#00A4FF"/>
        <path d="M3532.5 130.5H3396L3375 110.5V25L3352.5 8L3142.5 8" stroke="#00A4FF" stroke-width="2"/>
        <path d="M4082.5 130H4103.5V24.5L4122 5H4160.5" stroke="#00A4FF" stroke-width="2"/>
    </svg>
</template>
